import React from 'react';

import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Color, CommonProperties } from '../../styles';
import BaseText from '../BaseText';
import i18n from '../../i18n';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';
import { formatCurrency } from '../../utils/currency.utils';
const FixedNextButtonBar = ({ cartTotal, disabled, buttonLabel, onPress, response }) => {
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  return (
    <View style={[styles.container, disabled ? styles.containerDisabled : null]}>
      <View style={styles.leftSideContainer}>
        <View style={styles.cartTotalLine}>
          <BaseText style={styles.cartTotalText}>
            {response?.IsRedeem
              ? formatCurrency(response?.AirResponses[0].TotalTax, currency, currencyCulture)
              : formatCurrency(Number(cartTotal).toFixed(2), currency, currencyCulture)}
          </BaseText>
          {response?.IsRedeem && (
            <>
              <BaseText style={styles.cartTotalText}>
                {' +'} {response?.AirResponses[0].RedeemPoints}
              </BaseText>
              <BaseText>{' pts'}</BaseText>
            </>
          )}
        </View>
        <BaseText style={styles.totalPriceText}>{i18n.t('common:TotalPrice')}</BaseText>
      </View>

      <TouchableOpacity
        disabled={disabled}
        onPress={() => onPress()}
        style={styles.rightSideClickContainer}
      >
        <BaseText style={styles.rightSideButtonText}>
          {buttonLabel ? buttonLabel : i18n.t('common:Next')}
        </BaseText>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.primary,
    flexDirection: 'row',
    ...CommonProperties.py2,
    ...CommonProperties.px3,
  },
  containerDisabled: {
    backgroundColor: Color.disabled,
    opacity: 0.5,
  },
  leftSideContainer: {
    flex: 1,
    borderRightColor: Color.accent,
    borderRightWidth: 1,
  },
  cartTotalLine: {
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  cartTotalText: {
    color: Color.accent,
    ...CommonProperties.h1,
  },
  currencyText: {
    color: Color.accent,
    ...CommonProperties.ml1,
    ...CommonProperties.small,
  },
  totalPriceText: {
    color: Color.accent,
    marginTop: -8,
    ...CommonProperties.small,
  },
  rightSideClickContainer: {
    flex: 1,
    ...CommonProperties.centerAlignment,
  },
  rightSideButtonText: {
    color: Color.accent,
    ...CommonProperties.h4,
  },
});

export default FixedNextButtonBar;
